module.exports = __webpack_public_path__ + "static/media/amalfi.f411c1cc.jpeg";